const e=async e=>{let{data:t}=await e.get(`/auth/whoami`);return t};export{e as whoami};
//# sourceMappingURL=whoami.mjs.map